module.exports = __webpack_public_path__ + "img/hydro-rocketry-thumb.95a1d4ee.jpg";